// export const tableHeaders = [
//   { label: 'ID', value: 'gameSubCategoryId' },
//   // { label: 'Casino Game Id', value: 'casinoGameId' },
//   { label: 'Name', value: 'name' },
//   { label: 'Game Category', value: 'categoryname' },
//   { label: 'Thumbnail', value: 'thumbnail' },  
//   // { label: 'System', value: 'system' },
//   // { label: 'Country Restriction Id', value: 'idCountryRestriction' },
//   // { label: 'Status', value: 'status' },
//   { label: 'Actions', value: 'Actions' }

// ]


export const tableHeaders = [
  {
    label: 'ID',
    value: 'casinoGameId',
    accessorKey: 'casinoGameId',
    Header: 'casinoGameId',
  },
  // {
  //   label: 'Casino Game Id',
  //   value: 'casinoGameId',
  //   accessorKey: 'casinoGameId',
  //   Header: 'casinoGameId',
  // },
  {
    label: 'Name',
    value: 'name',
    accessorKey: 'name',
    Header: 'name',
  },
  {
    label: 'Game Category',
    value: 'categoryname',
    accessorKey: 'categoryname',
    Header: 'categoryname',
  },
  {
    label: 'Thumbnail',
    value: 'thumbnail',
    accessorKey: 'thumbnail',
    Header: 'thumbnail',
  },
  // {
  //   label: 'System',
  //   value: 'system',
  //   accessorKey: 'system',
  //   Header: 'system',
  // },
  // {
  //   label: 'Country Restriction Id',
  //   value: 'idCountryRestriction',
  //   accessorKey: 'idCountryRestriction',
  //   Header: 'idCountryRestriction',
  // },
  // {
  //   label: 'Status',
  //   value: 'status',
  //   accessorKey: 'status',
  //   Header: 'status',
  // },
  {
    label: 'Actions',
    value: 'action',
    accessorKey: 'action',
    Header: 'action',
  },
];
